import { Routes, Route, Navigate } from "react-router-dom";
import AppDownloadPage from "./pages/AppDownloadPage";
import RegisterPage from "./pages/RegisterPage";
import VerifyPage from "./pages/VerifyPage";
import PosFlowPage from "./pages/PosFlowPage";
import LandingPage from "./pages/LandingPage/LandingPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import AdminLayout from "./pages/AdminLayout/AdminLayout";
import AdminCalendarPage from "./pages/AdminCalendarPage/AdminCalendarPage";
import AdminClientsPage from "./pages/AdminClientsPage/AdminClientsPage";
import AdminSalesPage from "./pages/AdminSalesPage/AdminSalesPage";
import AdminReportsPage from "./pages/AdminReportsPage/AdminReportsPage";
import AdminSettingsPage from "./pages/AdminSettingsPage/AdminSettingsPage";
import AdminProductsPage from "./pages/AdminProductsPage/AdminProductsPage";
import AdminPayrollPage from "./pages/AdminPayrollPage/AdminPayrollPage";
import AdminBoothRentalPage from "./pages/AdminBoothRentalPage/AdminBoothRentalPage";
import AdminBoothClientsPage from "./pages/AdminBoothClientsPage/AdminBoothClientsPage";
import AdminBoothSettingsPage from "./pages/AdminBoothSettingsPage/AdminBoothSettingsPage";
import AdminDigitalFormsPage from "./pages/AdminDigitalFormsPage/AdminDigitalFormsPage";
import AdminWaitlistManagerPage from "./pages/AdminWaitlistManagerPage/AdminWaitlistManagerPage";
import AdminWalkInKioskPage from "./pages/AdminWalkInKioskPage/AdminWalkInKioskPage";
import AdminAccountingPage from "./pages/AdminAccountingPage/AdminAccountingPage";
import AdminAITelephonyPage from "./pages/AdminAITelephonyPage/AdminAITelephonyPage";
import AdminClientConnectPage from "./pages/AdminClientConnectPage/AdminClientConnectPage";
import AdminMembershipsPage from "./pages/AdminMembershipsPage/AdminMembershipsPage";
import AdminMultiLocationPage from "./pages/AdminMultiLocationPage/AdminMultiLocationPage";
import PublicWaitlistClaimPage from "./pages/PublicWaitlistClaimPage";
import PublicBookingPage from "./pages/PublicBookingPage/PublicBookingPage";
import ClientAppPage from "./pages/ClientApp/ClientAppPage";
import DemoRequestPage from "./pages/DemoRequestPage";
import NotFoundPage from "./pages/NotFoundPage";
import PrivacyPolicyPage from "./pages/legal/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/legal/TermsOfServicePage";
import ClientTermsPage from "./pages/legal/ClientTermsPage";


function App() {
  return (
    <Routes>
      <Route path='/' element={<LandingPage/>} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="calendar" replace />} />
        <Route path="calendar" element={<AdminCalendarPage />} />
        <Route path="clients" element={<AdminClientsPage />} />
        <Route path="sales" element={<AdminSalesPage />} />
        <Route path="reports" element={<AdminReportsPage />} />
        <Route path="settings" element={<AdminSettingsPage />} />
        <Route path="products" element={<AdminProductsPage />} />
        <Route path="payroll" element={<AdminPayrollPage />} />
        <Route path="booth-rental" element={<AdminBoothRentalPage />} />
        <Route path="booth-clients" element={<AdminBoothClientsPage />} />
        <Route path="booth-settings" element={<AdminBoothSettingsPage />} />
        <Route path="forms" element={<AdminDigitalFormsPage />} />
        <Route path="waitlist" element={<AdminWaitlistManagerPage />} />
        <Route path="walkin" element={<AdminWalkInKioskPage />} />
        <Route path="accounting" element={<AdminAccountingPage />} />
        <Route path="telephony" element={<AdminAITelephonyPage />} />
        <Route path="connect" element={<AdminClientConnectPage />} />
        <Route path="memberships" element={<AdminMembershipsPage />} />
        <Route path="locations" element={<AdminMultiLocationPage />} />
      </Route>
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify" element={<VerifyPage />} />
      <Route path="/download" element={<AppDownloadPage />} />
      <Route path="/pos/*" element={<PosFlowPage />} />
      <Route path="/book/:slug" element={<PublicBookingPage />} />
      <Route path="/waitlist-claim/:token" element={<PublicWaitlistClaimPage />} />
      <Route path="/app/:slug" element={<ClientAppPage />} />
      <Route path="/demo" element={<DemoRequestPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsOfServicePage />} />
      <Route path="/client-terms" element={<ClientTermsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
